import { createAsyncStore } from "common/axios/asyncModel";
import { PaymentRepository } from "repository/paymentRepository";

// 정산 목록 조회
const paymentList = createAsyncStore();
const onGetPaymentList = (meetingId: string) => {
    paymentList.onGetAll(() => PaymentRepository.onGetPayments(meetingId));
}

// 정산 상세 조회
const paymentDetail = createAsyncStore();
const onGetPaymentDetail = (paymentId: string) => {
    paymentDetail.onGetAll(() => PaymentRepository.onGetPaymentDetail(paymentId));
}

// 정산 생성
const createPayment = createAsyncStore();
const onCreatePayment = (meetingId: string, params: any) => {
    createPayment.onGetAll(() => PaymentRepository.onPostCreatePayment(meetingId, params));
}

// 정산 요청
const requestPayment = createAsyncStore();
const onRequestPayment = (paymentId: string, params?: any) => {
    requestPayment.onGetAll(() => PaymentRepository.onPostRequestPayment(paymentId, params));
}

// 정산 완료
const completePayment = createAsyncStore();
const onCompletePayment = (paymentId: string, params?: any) => {
    completePayment.onGetAll(() => PaymentRepository.onPostCompletePayment(paymentId, params));
}

// 영수증 OCR — file 을 받아 wiz-common 업로드 → wizai 분석 2단계 chain.
// 결과 data: { imageUrl, storeName, totalAmount, items, receiptDate?, confidence? } (지출등록 form prefill 용)
const receiptOcr = createAsyncStore();
const onReceiptOcr = async (_meetingId: string, file: File) => {
    receiptOcr.onPending();
    try {
        const uploadRes: any = await PaymentRepository.onUploadReceiptImage(file);
        // onRequest 는 에러 시 error.response 를 반환하므로 HTTP status 를 직접 검사해야 함
        const uploadOk = uploadRes && uploadRes.status >= 200 && uploadRes.status < 300;
        // wiz-common 은 ApiResponse<T> wrapper → response.data.data.fileUrl
        const imageUrl = uploadOk ? uploadRes?.data?.data?.fileUrl : null;
        if (!imageUrl) {
            console.error('[receipt-ocr] 업로드 실패:', uploadRes?.status, uploadRes?.data);
            throw new Error('영수증 이미지 업로드에 실패했습니다');
        }
        const aiRes: any = await PaymentRepository.onAnalyzeReceipt(imageUrl);
        // wizai 503/4xx 도 error.response 로 들어오므로 status 검사 — 검사 없으면 에러 body 가
        // OCR 결과로 오인되어 '인식 완료 0원' 으로 위장됨
        if (!aiRes || aiRes.status < 200 || aiRes.status >= 300) {
            console.error('[receipt-ocr] wizai 분석 실패:', aiRes?.status, aiRes?.data);
            throw new Error('영수증 분석 서비스가 일시적으로 응답하지 않습니다');
        }
        const ai = aiRes?.data || {};
        // wizai 응답 (snake_case) → 프론트 표준 (camelCase) 매핑
        receiptOcr.onReady({
            imageUrl,
            storeName: ai.store_name ?? null,
            totalAmount: ai.total ?? null,
            receiptDate: ai.receipt_date ?? null,
            items: ai.items ?? [],
            confidence: ai.confidence ?? null,
        });
    } catch (e: any) {
        receiptOcr.onError({ message: e?.message || '영수증 OCR 실패' });
    }
}

export const paymentStore = {
    paymentList,
    onGetPaymentList,

    paymentDetail,
    onGetPaymentDetail,

    createPayment,
    onCreatePayment,

    requestPayment,
    onRequestPayment,

    completePayment,
    onCompletePayment,

    receiptOcr,
    onReceiptOcr
}
